<template src="./Add.html"></template>

<script>

const DEFAULT_PASSWORD = "Aa@12345";

export default {
  created() {
    this.$store.dispatch("users/getFeatures");
    this.$store.dispatch("lookups/getLookups");
  },
  computed: {
    administrationTypes() {
            return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.AdministrationTypes)

        },
        administrations() {
            return [
                ...this.$store.state.lookups.administrations
            ]
        },
        departments() {
            return this.$store.state.lookups.departments;
        },
        units() {
            return this.$store.state.lookups.units;
        },
        systemTypes(){
          return [
            {value:true,label:"واجهة الادارة"},
            {value:false,label:"واجهة الموظف"},
          ]

        },
    features() {
      return this.$store.state.users.features;
    },
    userTypes(){
      return     this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.UserTypes)

      // return [
      //   {value:1,label:"المدير العام"},
      //   {value:2,label:"مدير شؤون الموظفين"},
      //   {value:3,label:"موظف"},
      // ]
    }
  },
  data() {
    return {
      user: {
        isMainSystem: false,
        userTypeId: null,
        permissions: [],
      },
      filters:{
        administrationTypeId:null,
        administrationId:null,
        departmentId:null,
        unitId:null,
      },
      employees:[],
    };
  },
  methods: {
    changeCheckbox(){
        this.user.permissions = [];
        this.user.userTypeId = null;
        this.HandleChange();
    },
    getEmployees() {
      this.employees = [];
      this.$store.dispatch("users/getEmployees", this.filters).then((res)=>
      {
        this.employees = res;
      })
    },
    changeType() {
            this.filters.administrationId = null;
            this.filters.departmentId = null;
            this.filters.unitId = null;
            this.$store.dispatch("lookups/getAdministrationsByType", this.filters.administrationTypeId);
           // this.getEmployees();
        },
        changeAdministration() {
            this.filters.departmentId = null;
            this.filters.unitId = null;
            if (this.filters.administrationTypeId != 1002) {
                this.$store.dispatch("lookups/getDepartments", this.filters.administrationId);
            }
            else {
                this.$store.dispatch("lookups/getUnitsById", {
                    typeId: 1,
                    id: this.filters.administrationId,
                });

            }
            this.getEmployees();

        },
        changeDepartment() {
            this.filters.unitId = null;
            this.$store.dispatch("lookups/getUnitsById", {
                typeId: 2,
                id: this.filters.departmentId,
            });
            this.getEmployees();

        },

    confirm() {
      const payload = {
        ...this.user,
        password: DEFAULT_PASSWORD,
      };

      this.$store
        .dispatch("users/add", payload)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    CheckAll(feature) {
      feature.permissions.forEach((permission) => {
        if (feature.checkAll) {
          if (!this.user.permissions.includes(permission.permissionId)) {
            this.user.permissions.unshift(permission.permissionId);
          }
        } else {
          if (this.user.permissions.includes(permission.permissionId)) {
            let index = this.user.permissions.indexOf(permission.permissionId);
            this.user.permissions.splice(index, 1);
          }
        }
      });
    },

    HandleChange(feature) {
      feature.checkAll = true;
      feature.permissions.forEach((permission) => {
        if (!this.user.permissions.includes(permission.permissionId)) {
          feature.checkAll = false;
        }
      });
    },
    allowedDates(val) {
      const today = new Date();
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>